
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_1sdq3_1ns03_141",
  "input": "awsui_input_1sdq3_1ns03_176",
  "results": "awsui_results_1sdq3_1ns03_180"
};
  